import clsx from "clsx"
import "./style.sass"
import SimpleBar from "simplebar-react"
import { useEffect, useRef } from "react"
import { FormattedMessage } from "react-intl"

interface IStepperItem {
  name?: string
  name_id?: string
  path: string
}

interface IStepperProps {
  steps: IStepperItem[]
  className?: string
  currentStep: number
}

export const Stepper = ({ steps, className, currentStep }: IStepperProps) => {
  const ref = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    if (window.innerWidth > 800) return
    setTimeout(() => {
      if (ref.current != null) {
        const el = document.getElementById(`step_item${currentStep}`)
        // ref.current?.scrollTo({ left: (rect?.left ?? 0) - rect1.left, behavior: "smooth" })
        el?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
      }
    }, 100)
  }, [currentStep, ref])
  return (
    <SimpleBar
      scrollableNodeProps={{ ref: ref }}
      classNames={{ track: "hidden", contentEl: "flex justify-center" }}
      className="flex-[1_1_0] max-w-full pb-2 w-full"
    >
      <div className={clsx("custom-stepper w-full max-w-[716px]", className)}>
        {steps.map((step, index) => (
          <div
            key={index}
            id={`step_item${index + 1}`}
            className={clsx("custom-stepper__item", index < currentStep && "custom-stepper__item-active")}
          >
            <div>{index + 1}</div>
            <span>{step.name_id != null ? <FormattedMessage id={step.name_id} /> : step.name}</span>
          </div>
        ))}
      </div>
    </SimpleBar>
  )
}
